export enum SampleBackgroundType {
    Solid = 'solid',
    Gradient = 'gradient'
}
